import GloriaRose from '../../Images/landing-page/gloria-rose.png'
import Star from '../../Images/landing-page/Star.png'

export const TESTIFIERDATA = [
    {
        image: GloriaRose,
        testimony: `"Thank you so much for your help. It's exactly what
         I've been looking for. You won't regret it. It really saves me time 
         and effort. TOTC is exactly what our business has been lacking."`,
         testifier: 'Gloria Roses',
         rating: Star,
         noOfReviews: '12 reviews at Yelp'
    }
]